import { Injectable, inject } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuthService } from '../services/auth.service'

@Injectable({ providedIn: 'root' })
export class DashboardGuard {
  private authService = inject(AuthService)
  private router = inject(Router)

  async canActivate(): Promise<boolean | UrlTree> {
    const customer = this.authService.customer() ?? (await this.authService.ensureCustomerLoaded())
    return customer ? true : this.router.parseUrl('/dashboard/login')
  }
}
